export const CREATE_COSTESTIMATE_REQUEST =
  'inspection/CREATE_COSTESTIMATE_REQUEST';
export const CREATE_COSTESTIMATE_SUCCESS =
  'inspection/CREATE_COSTESTIMATE_SUCCESS';
export const CREATE_COSTESTIMATE_FAILURE =
  'inspection/CREATE_COSTESTIMATE_FAILURE';

export const READ_COSTESTIMATE_REQUEST = 'inspection/READ_COSTESTIMATE_REQUEST';
export const READ_COSTESTIMATE_SUCCESS = 'inspection/READ_COSTESTIMATE_SUCCESS';
export const READ_COSTESTIMATE_FAILURE = 'inspection/READ_COSTESTIMATE_FAILURE';

export const UPDATE_COSTESTIMATE_REQUEST =
  'inspection/UPDATE_COSTESTIMATE_REQUEST';
export const UPDATE_COSTESTIMATE_SUCCESS =
  'inspection/UPDATE_COSTESTIMATE_SUCCESS';
export const UPDATE_COSTESTIMATE_FAILURE =
  'inspection/UPDATE_COSTESTIMATE_FAILURE';

export const DELETE_COSTESTIMATE_REQUEST =
  'inspection/DELETE_COSTESTIMATE_REQUEST';
export const DELETE_COSTESTIMATE_SUCCESS =
  'inspection/DELETE_COSTESTIMATE_SUCCESS';
export const DELETE_COSTESTIMATE_FAILURE =
  'inspection/DELETE_COSTESTIMATE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/costEstimate/costEstimate.actionTypes.js